module.exports = __webpack_public_path__ + "static/media/Artboard12.9c9177c6.png";